import * as Actions from './actions';
import {Map, List} from 'immutable';
import {mergeEntitiesToState} from '../model/models';
import Cookies from 'js-cookie';

export default function reducer(state = new Map(), {type, payload}) {
    switch (type) {
        case Actions.THREAD_SIDEBAR_TOGGLE:

            let newState;

            if (payload === null) {
                newState = state
                    .update('threadSidebar', (open) => !open);
            } else {
                newState = state
                    .set('threadSidebar', payload);
            }

            Cookies.set('thread-sidebar-open', newState.get('threadSidebar'));

            return newState;

        case Actions.UPDATE_ENTITIES:
            return mergeEntitiesToState(state, payload);

        case Actions.THREAD_EVENTS_LOAD:
            return state
                .update('shownThreadEventsMeta', (meta) => meta.merge({
                    loading: true,
                    error: null,
                }));

        case Actions.THREAD_EVENTS_LOAD_SUCCESS:
            let hasPrev;

            if (payload.hasPrev === null) {
                hasPrev = state.getIn(['shownThreadEventsMeta', 'hasPrev']);
            } else {
                hasPrev = payload.hasPrev;
            }

            return state
                .update('shownThreadEventsMeta', (meta) => meta.merge({
                    loading: false,
                    error: null,
                    hasPrev,
                }))
                .update('shownThreadEvents', (events) => {
                    if (payload.direction === 'next') {
                        return events.concat(payload.events);
                    } else {
                        return (new List(payload.events)).concat(events);
                    }
                });

        case Actions.THREAD_EVENTS_LOAD_FAILURE:
            return state
                .update('shownThreadEventsMeta', (meta) => meta.merge({
                    loading: false,
                    error: payload,
                }));

        case Actions.THREAD_ADD_FILE_UPLOAD:
            return state
                .update('threadUploadedFiles', (files) => {
                    return files.push(payload.file);
                });
        case Actions.THREAD_REMOVE_UPLOAD_FILE:
            return state
                .update('threadUploadedFiles',
                    (files) => files.remove(files.indexOf(payload.file))
                );

        case Actions.THREAD_CLEAR_UPLOAD_FILES:
            return state
                .set('threadUploadedFiles', new List())
                .update('threadFileUploadMeta', (meta) => meta.merge({
                    value: '',
                }));

        case Actions.THREAD_FILE_UPLOAD:
            return state
                .update('threadFileUploadMeta', (meta) => meta.merge({
                    status: 0,
                    readyState: XMLHttpRequest.UNSENT,
                    inProgress: true,
                }));

        case Actions.THREAD_FILE_UPLOAD_UPDATE:
            return state
                .update('threadFileUploadMeta', (meta) => meta.merge({
                    status: payload.status,
                    readyState: payload.readyState,
                }));

        case Actions.THREAD_FILE_UPLOAD_COMPLETE:
            return state
                .update('threadFileUploadMeta', (meta) => meta.merge({
                    value: '',
                    inProgress: false,
                }));

        case Actions.THREAD_INPUT:
            return state
                .update('threadInputMeta', (meta) => meta.merge({
                    loading: true,
                    error: null,
                }));

        case Actions.THREAD_INPUT_SUCCESS:
            return state
                .update('threadInputMeta', (meta) => meta.merge({
                    loading: false,
                    error: null,
                }));

        case Actions.THREAD_INPUT_FAILURE:
            return state
                .update('threadInputMeta', (meta) => meta.merge({
                    loading: false,
                    error: payload,
                }));

        case Actions.THREAD_WORKFLOW_STATUS_UPDATE:
            return state
                .update('threadWorkflowStatusMeta', (meta) => meta.merge({
                    loading: true,
                    error: null,
                }));

        case Actions.THREAD_WORKFLOW_STATUS_UPDATE_SUCCESS:
            return state
                .update('threadWorkflowStatusMeta', (meta) => meta.merge({
                    loading: false,
                    error: null,
                }))
                .updateIn(['threads', state.get('currentThread')], (thread) => (
                    thread.set('workflowStatus', payload)
                ));
        case Actions.THREAD_WORKFLOW_STATUS_UPDATE_FAILURE:
            return state
                .update('threadWorkflowStatusMeta', (meta) => meta.merge({
                    loading: false,
                    error: payload,
                }));

        case Actions.THREAD_OWNER_UPDATE:
            return state
                .update('threadOwnerMeta', (meta) => meta.merge({
                    loading: true,
                    error: null,
                }));

        case Actions.THREAD_OWNER_UPDATE_SUCCESS:
            return state
                .update('threadOwnerMeta', (meta) => meta.merge({
                    loading: false,
                    error: null,
                }));

        case Actions.THREAD_OWNER_UPDATE_FAILURE:
            return state
                .update('threadOwnerMeta', (meta) => meta.merge({
                    loading: false,
                    error: payload,
                }));

        case Actions.THREAD_NOTE_UPDATE:
            return state
                .update('threadNoteMeta', (meta) => meta.merge({
                    loading: true,
                    error: null,
                }));

        case Actions.THREAD_NOTE_UPDATE_SUCCESS:
            return state
                .update('threadNoteMeta', (meta) => meta.merge({
                    loading: false,
                    error: null,
                }))
                .updateIn(['threads', state.get('currentThread')], (thread) => (
                    thread.set('note', payload)
                ));

        case Actions.THREAD_NOTE_UPDATE_FAILURE:
            return state
                .update('threadNoteMeta', (meta) => meta.merge({
                    loading: false,
                    error: payload,
                }));

        default:
            return state;
    }
}
